'use client'

import Link from 'next/link'
import {useTranslation} from '../../../hooks/useTranslation'

/**
 * The one line above every guest booking form for a visitor who should sign in instead: an account,
 * a pass or a discount code works only after signing in, and signing in also creates an account.
 * A lower first-entry price, which guests never get, is the stronger reason and replaces the question.
 */
export function GuestSignInHint({href, firstEntry = null}: {href: string; firstEntry?: string | null}) {
    const {t} = useTranslation('landing')
    return (
        <p className="rounded-lg bg-[var(--landing-neutral-50)] px-4 py-3 text-sm text-[var(--landing-neutral-700)]">
            {firstEntry
                ? t('publicEntry.guestCheckout.formFirstEntryHint', {amount: firstEntry})
                : t('publicEntry.guestCheckout.formAccountHint')}{' '}
            <Link href={href} className="font-semibold text-primary-600 underline-offset-2 hover:underline">{t('publicEntry.guestCheckout.signIn')}</Link>
        </p>
    )
}
